var ModalReject = {

  controller: function () {
    this.data = {}
  },
  view: function (ctrl, args) {

    return m('div.dm-overlay',
      m("div.dm-table", [
        m("div.dm-cell", [
          m("div.dm-modal", [
            m(".bg-primary[style='padding:10px;z-index:1;']", [
              m("span[id='modalTitleLmc'][style='margin-right: 15px']", "Предупреждение"),
              m("span.pull-right[style='cursor: pointer;']", {
                onclick: ModalContainerReject.close
              }, [
                m("i.glyphicon.glyphicon-remove"),
                m.trust('&nbsp;Закрыть')
              ])
            ]),
            [
              m("div", [
                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                  m("div[style='']", [
                    m("div[id='modalContentLmc'][style='text-align: center']", "Вы уверены, что хотите отклонить Loadsheet?"),
                    m(".row[style='text-align: center; margin-top: 15px']", [
                      m("button[style='margin-right: 10px'].btn.btn-warning.btn-lg", {
                        //id: "",
                        onclick: function () {
                          ModalContainerReject.close();
                        }
                      }, "Отмена"),
                      m("button.btn.btn-warning.btn-lg", {
                        onclick: function () {
                          m.request({
                          	method: "PUT",
                          	url: `/api/task/${m.route.param("taskId")}/setLoadSheet`,
                          	data: ModalContainerReject.data
                          }).then(() => {
                            m.route(`/task/${m.route.param('taskId')}/loadsheet`)
                            ModalContainerReject.close();
                          })
                        }
                      }, "Отклонить"),
                    ]),
                  ]),
                ])
              ])
            ]
          ])
        ])
      ])
    );
  }
};

export var ModalContainerReject = {
  container: null,
  idElement: null,
  init: function () {
    ModalContainerReject.container = document.querySelector('#ModalReject');
    if (!ModalContainerReject.container) {
      ModalContainerReject.container = document.createElement('div');
      ModalContainerReject.container.id = 'ModalReject';
      ModalContainerReject.container.hidden = true;
      document.body.appendChild(ModalContainerReject.container);
      m.mount(ModalContainerReject.container, m.component(ModalReject, {data:  "", type: false, idElement: ""}));
    }
  },
  open: function (data) {
    ModalContainerReject.container = document.querySelector('#ModalReject');
    if(typeof(idElement) != "undefined" && idElement !== null)
      ModalContainerReject.idElement = idElement;
    if(typeof(removeAll) != "undefined" && removeAll !== null)
      ModalContainerReject.removeAll = removeAll;
    if (ModalContainerReject.container) {
      ModalContainerReject.container.hidden = false;
    }
    ModalContainerReject.data = data

  },
  close: function () {
    ModalContainerReject.container.hidden = true;
  }
};
